export const fetchWithRetry = async (
	url: RequestInfo | URL,
	options = {},
	maxRetries = 3,
	retryOnServerError = false,
	onRetry?: (attempt: number, maxRetries: number, url: RequestInfo | URL) => void
) => {
	let lastError: unknown;

	for (let i = 0; i < maxRetries; i++) {
		try {
			const response = await fetch(url, options);

			if (retryOnServerError && response.status >= 500 && i < maxRetries - 1) {
				onRetry?.(i + 1, maxRetries, url);
				lastError = new Error(`Server error: ${response.status}`);
			} else {
				return response;
			}
		} catch (error: unknown) {
			lastError = error;
		}

		// Wait before retrying (exponential backoff)
		if (i < maxRetries - 1) {
			await new Promise((resolve) => setTimeout(resolve, 1000 * Math.pow(2, i)));
		}
	}

	throw lastError;
};
